import { HabitSchedule, Timestamp } from '@griply/types';

import { getActiveSchedule } from './get-active-schedule';

// A habit has ended when it has schedules but none of them are still active
// (every schedule's endDate is in the past). A scheduleless habit is not ended.
export const isHabitEnded = (
  schedules: HabitSchedule[] | undefined | null,
  today: Timestamp,
): boolean => !!schedules?.length && !getActiveSchedule(schedules, today);
